<p-toast position="top-center"></p-toast>
<sg-loading [visible]="IsVisible"></sg-loading>

<div class="background blue contenedor">
    <div class="sub-contenedor">
        <div class="contenedor-circular">
            <img src="../../../../../../assets/svg/logoSigessRedondo.svg" alt="">
        </div>
        <div class="contenedor-cuadrado">
            <div class="" style="margin-top: 73px;">      
                    <p>Ingrese el correo para restaurar la contraseña</p>          
                    <form [formGroup]="formLogin" role="form">
                        <mat-form-field appearance="outline" style=" width: 74%; margin-top: 30px;">
                            <mat-label>Correo</mat-label>
                            <input type="email" formControlName="correo" matInput autocomplete="off">
                        </mat-form-field>
                        <div style="margin-top: 30px;">
                            <button style="margin-right: 10px;" class="button-round button-orange" routerLink="/login" mat-raised-button color="primary">Regresar</button>


                            <button class="button-round button-gray text-color-white" *ngIf="formLogin.invalid || !visibleLnkResetPasswd" mat-raised-button color="disabled">Recuperar</button>
                            <button class="button-round button-orange" *ngIf="formLogin.valid && visibleLnkResetPasswd" (click)="reset(formLogin.value)" mat-raised-button color="primary">Recuperar</button>
                        </div>
                    </form>   
                   
            </div>   
        </div>        
    </div>
</div>
